import { create } from 'zustand'

export type Action = {
    title: string
    icon?: React.ReactNode;
    description?: string
    href?: string
    action?: () => void;
}

export type Page = {
    url: string
    title: string
    actions: Action[]
}

export type AppState = {
    page: Page | null
    setPage: (pathname: string, title?: string, actions?: Action[]) => void
}

export const useAppStore = create<AppState>((set, get) => ({
    page: null,
    setPage: (pathname, title, actions) => {
        if (title || actions) {
            set({
                page: {
                    url: pathname,
                    title: title || "",
                    actions: actions || []
                }
            })
        } else {
            const currentPage = get().page;
            if (!currentPage?.url || !pathname.startsWith(currentPage.url)) {
                set({ page: null })
            }
        }
    }
}))